import React from 'react'
import { Modal } from "react-bootstrap";

export default function ModalPopup(props) {
    return (
        <>
            <Modal class="modal-content" dialogClassName={"primaryModal"} size="md" aria-labelledby="example-custom-modal-styling-title" show={props.show} onHide={props.handleClose} id="myModalEvent1">
                <Modal.Header >
                    {props.header}
                </Modal.Header>
                <Modal.Body>
                    {props.body}
                </Modal.Body>
                <Modal.Footer>
                    {props.footer}
                </Modal.Footer>
            </Modal>
        </>
    )
}